<script setup lang="ts">
import DashboardLayout from '@/onenetwork/layouts/DashboardLayout.vue'
</script>
<template>
  <dashboard-layout currentRoute="customers/list" page-title="Quản lý khách hàng">
  </dashboard-layout>
</template>
